import React from 'react';

export default function HorseEarsSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="29.68,13.67 22.25,16.75 17.41,5.08 24.84,2.0" fill="#E1D4E1" />
      <polygon points="29.68,13.67 22.25,16.75 17.41,5.08 24.84,2.0" fill="#E1D4E1" />
      <polygon points="17.75,16.75 10.32,13.67 15.16,2.0 22.59,5.08" fill="#E1D4E1" />
      <polygon points="17.75,16.75 10.32,13.67 15.16,2.0 22.59,5.08" fill="#E1D4E1" />
      <polygon points="27.81,13.84 23.56,15.6 19.6,6.04 23.85,4.29" fill="#E1D4E1" />
      <polygon points="23.56,15.6 27.81,13.84 27.12,13.49 22.87,15.25" fill="#B797B7" opacity="0.95" />
      <polygon points="23.56,15.6 22.87,15.25 18.92,5.7 19.6,6.04" fill="#B797B7" opacity="0.95" />
      <polygon points="17.82,15.6 13.57,13.84 17.53,4.29 21.77,6.04" fill="#E1D4E1" />
      <polygon points="13.57,13.84 12.88,13.49 16.84,3.94 17.53,4.29" fill="#B797B7" opacity="0.95" />
      <polygon points="22.32,38.0 17.73,38.0 18.26,34.02 22.85,34.02" fill="#E1D4E1" />
      <polygon points="17.73,38.0 22.32,38.0 20.41,34.41 15.82,34.41" fill="#B797B7" opacity="0.95" />
      <polygon points="17.73,38.0 15.82,34.41 16.35,30.43 18.26,34.02" fill="#B797B7" opacity="0.95" />
      <polygon points="22.32,38.0 17.73,38.0 18.26,34.02 22.85,34.02" fill="#E1D4E1" />
      <polygon points="17.73,38.0 22.32,38.0 20.41,34.41 15.82,34.41" fill="#B797B7" opacity="0.95" />
      <polygon points="17.73,38.0 15.82,34.41 16.35,30.43 18.26,34.02" fill="#B797B7" opacity="0.95" />
      <polygon points="22.85,34.02 18.26,34.02 20.37,18.09 24.96,18.09" fill="#E1D4E1" />
      <polygon points="18.26,34.02 22.85,34.02 20.94,30.43 16.35,30.43" fill="#B797B7" opacity="0.95" />
      <polygon points="18.26,34.02 16.35,30.43 18.46,14.5 20.37,18.09" fill="#B797B7" opacity="0.95" />
      <polygon points="25.25,12.88 22.84,12.88 22.05,6.11 24.46,6.11" fill="#E1D4E1" />
      <polygon points="22.84,12.88 25.25,12.88 22.07,15.68 19.66,15.68" fill="#B797B7" opacity="0.95" />
      <polygon points="22.84,12.88 19.66,15.68 18.86,8.92 22.05,6.11" fill="#B797B7" opacity="0.95" />
      <polygon points="23.59,23.51 21.3,23.51 22.09,17.53 24.38,17.53" fill="#E1D4E1" />
      <polygon points="21.3,23.51 23.59,23.51 21.05,18.72 18.75,18.72" fill="#B797B7" opacity="0.95" />
      <polygon points="21.3,23.51 18.75,18.72 19.54,12.74 22.09,17.53" fill="#B797B7" opacity="0.95" />
      <polygon points="25.99,34.08 23.69,34.08 23.69,15.7 25.99,15.7" fill="#E1D4E1" />
      <polygon points="23.69,34.08 25.99,34.08 23.92,33.04 21.62,33.04" fill="#B797B7" opacity="0.95" />
      <polygon points="23.69,34.08 21.62,33.04 21.62,14.66 23.69,15.7" fill="#B797B7" opacity="0.95" />
    </svg>
  );
}
